import * as React from 'react';
export const thumbsDownSvg = React.forwardRef(function thumbsDownSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.848 16a2.62 2.62 0 0 1-2.611-2.838l.254-3.054a.1.1 0 0 0-.1-.108H2.5C1.12 10 0 8.857 0 7.477c0-.31.072-.622.211-.9L.75 5.5V4.355a1 1 0 0 1 .224-.63L1.563 3l.28-.895A3 3 0 0 1 4.705 0H14a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2l-.001.002-2.545 5.94A1.747 1.747 0 0 1 7.848 16ZM10.5 8.692V1.5H4.706a1.5 1.5 0 0 0-1.432 1.053l-.28.894a1.5 1.5 0 0 1-.267.499l-.477.587V5.5a1.5 1.5 0 0 1-.158.67l-.54 1.079a.519.519 0 0 0-.052.228c0 .57.466 1.023 1 1.023h2.891a1.6 1.6 0 0 1 1.595 1.733l-.255 3.053A1.12 1.12 0 0 0 7.848 14.5a.247.247 0 0 0 .227-.15L10.5 8.692ZM12 7.5h2a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5h-2v6Z',
    }),
  );
});
thumbsDownSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var thumbsDown = {
  category: 'icon',
  colorable: true,
  name: 'thumbsDown',
  svg: thumbsDownSvg,
};
